import { Box, IconButton, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import YouTubeIcon from '@mui/icons-material/YouTube';
import React from 'react';
import { Specialization } from './gw2components';
import ModalVideo from './ModalVideo';

const useStyles = makeStyles()((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  youtubeIcon: {
    color: '#FF0000',
  },
}));

interface ProfessionVideoProps {
  src: string;
  title: string;
  profession: string;
  timestamp?: number;
}

function ProfessionVideo({
  profession = '',
  title,
  src,
  timestamp,
}: ProfessionVideoProps) {
  const { classes } = useStyles();
  return (
    <Box display="flex" alignItems="center" className={classes.root}>
      <Box>
        <ModalVideo src={src} timestamp={timestamp} title={title}>
          {(handleOpen) => (
            <IconButton onClick={handleOpen} size="large">
              <YouTubeIcon className={classes.youtubeIcon} />
            </IconButton>
          )}
        </ModalVideo>
      </Box>
      <Box alignSelf="center">
        <Specialization
          //@ts-ignore
          name={profession}
          disableLink
          {...(title ? { text: title } : {})}
        />
        <Typography variant="caption" sx={{ display: 'block' }}>
          Click to play!
        </Typography>
      </Box>
    </Box>
  );
}

export default ProfessionVideo;
